import { render, staticRenderFns } from "./PurchasesOrderForm.vue?vue&type=template&id=1c0e3686"
import script from "./PurchasesOrderForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports